// AUTO-GENERATED from `pine_medium.json` — do not edit by hand. Regenerate via the preset
//   → `.ts` conversion script when the upstream preset JSONs change.
import type {DeepPartial, TreeOptions} from "../options.js";

const options: DeepPartial<TreeOptions> = {
    "seed": 13977,
    "type": "evergreen",
    "bark": {
      "type": "Bark003",
      "tint": 16777215,
      "flatShading": false,
      "textured": true,
      "textureScale": {
        "x": 1,
        "y": 1
      }
    },
    "branch": {
      "levels": 1,
      "angle": {
        "1": 110,
        "2": 16,
        "3": 60
      },
      "children": {
        "0": 82,
        "1": 3,
        "2": 5
      },
      "force": {
        "direction": {
          "x": 0,
          "y": 1,
          "z": 0
        },
        "strength": -0.003
      },
      "gnarliness": {
        "0": 0.05,
        "1": 0.08,
        "2": 0,
        "3": 0
      },
      "length": {
        "0": 50,
        "1": 23.87,
        "2": 14.08,
        "3": 1
      },
      "radius": {
        "0": 1.05,
        "1": 0.36,
        "2": 0.7,
        "3": 0.7
      },
      "sections": {
        "0": 12,
        "1": 10,
        "2": 8,
        "3": 6
      },
      "segments": {
        "0": 8,
        "1": 6,
        "2": 4,
        "3": 3
      },
      "start": {
        "1": 0.27,
        "2": 0.14,
        "3": 0.3
      },
      "taper": {
        "0": 0.7,
        "1": 0.7,
        "2": 0.7,
        "3": 0.7
      },
      "twist": {
        "0": 0,
        "1": 0,
        "2": 0,
        "3": 0
      }
    },
    "leaves": {
      "type": "pine",
      "billboard": "double",
      "angle": 39,
      "count": 30,
      "start": 0.09,
      "size": 1.435,
      "sizeVariance": 0.201,
      "tint": 16777215,
      "alphaTest": 0.3
    },
    "trellis": {
      "enabled": false
    }
  };

export default options;
